/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckWizardAssignmentConflictsRequestDto
 */
export interface CheckWizardAssignmentConflictsRequestDto {
    /**
     * Selected asset ids to check for an existing active plan
     * @type {Array<string>}
     * @memberof CheckWizardAssignmentConflictsRequestDto
     */
    assetIds: Array<string>;
    /**
     * Assignment start date (YYYY-MM-DD). Required for Step 3 continue; conflict rules today use active assignments only.
     * @type {Date}
     * @memberof CheckWizardAssignmentConflictsRequestDto
     */
    startDate: Date;
}

/**
 * Check if a given object implements the CheckWizardAssignmentConflictsRequestDto interface.
 */
export function instanceOfCheckWizardAssignmentConflictsRequestDto(value: object): value is CheckWizardAssignmentConflictsRequestDto {
    if (!('assetIds' in value) || value['assetIds'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    return true;
}

export function CheckWizardAssignmentConflictsRequestDtoFromJSON(json: any): CheckWizardAssignmentConflictsRequestDto {
    return CheckWizardAssignmentConflictsRequestDtoFromJSONTyped(json, false);
}

export function CheckWizardAssignmentConflictsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckWizardAssignmentConflictsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetIds': json['assetIds'],
        'startDate': (new Date(json['startDate'])),
    };
}

export function CheckWizardAssignmentConflictsRequestDtoToJSON(json: any): CheckWizardAssignmentConflictsRequestDto {
    return CheckWizardAssignmentConflictsRequestDtoToJSONTyped(json, false);
}

export function CheckWizardAssignmentConflictsRequestDtoToJSONTyped(value?: CheckWizardAssignmentConflictsRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetIds': value['assetIds'],
        'startDate': value['startDate'].toISOString().substring(0,10),
    };
}

